<template>
  <div style="display: flex">
    <auto-number-input
      :value="value"
      :precision="3"
      style="flex: 1"
      :disabled="disabled"
      :min="0"
      @input="onInput"
      @change="onChange"
    />
    <span style="min-width: 50px;line-height: 28px;">CBM</span>
  </div>
</template>

<script>
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'

export default {
  name: 'SeMblCubage',
  components: {
    AutoNumberInput
  },
  props: {
    value: { type: [String, Number], required: true },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onChange(value) {
      this.$emit('change', value)
    }
  }
}
</script>
